import React, { useEffect } from 'react'
import { shallowEqual, useDispatch, useSelector } from 'react-redux'
import { useParams } from 'react-router'
import useTitle from 'utils/customHook/useTitle'
import i18n from 'simple-react-i18n'
import RpqsAction from 'rpqs/actions/RpqsAction'
import RpqsDocumentsPanel from '../documents/RpqsDocumentsPanel'

const ManagementEntityDocumentsApp = () => {
    const {
        rpqs,
        collectivities,
        managementUnitProps,
    } = useSelector(store => ({
        rpqs: store.RpqsReducer.rpqs,
        collectivities: store.RpqsReducer.collectivities,
        managementUnitProps: store.RpqsReducer.managementUnit,
    }), shallowEqual)

    const { annee, idCollectivite, ideg } = useParams()
    const dispatch = useDispatch()

    useEffect(() => {
        dispatch(RpqsAction.fetchAllCollectivities())
    }, [dispatch])

    const collectivity = collectivities.find(c => c.id === rpqs.collectivityId)

    const year = rpqs.year || `${i18n.year} ${i18n.unknown}`
    const managementEntityPropsName = managementUnitProps.name || `${i18n.managementEntity} ${i18n.unknown}`

    useTitle(() => [{
        title: i18n.rpqs,
        href: 'rpqs',
    }, {
        title: year,
        href: 'rpqs',
    }, {
        title: rpqs.name,
        href: `rpqs/${annee}/collectivite/${idCollectivite}`,
    }, {
        title: managementEntityPropsName,
        href: `rpqs/${annee}/collectivite/${idCollectivite}/eg/${ideg}/dashboard`,
    }], [collectivity, managementUnitProps, annee, idCollectivite, ideg])

    return <RpqsDocumentsPanel year={annee} collectivityId={idCollectivite} egId={ideg} />
}

export default ManagementEntityDocumentsApp
